import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/storage";
import "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBGSz2-q4dzkPCNbAxSyBRR7oBvzfnRawk",
  authDomain: "mydcrm-com.firebaseapp.com",
  databaseURL: "https://mydcrm-com.firebaseio.com",
  projectId: "mydcrm-com",
  storageBucket: "mydcrm-com.appspot.com",
  messagingSenderId: "300410362083",
  appId: "1:300410362083:web:6a5686b7fe7e7b60bacdd6",
  measurementId: "G-WXRXVF08X5"
};

firebase.initializeApp(firebaseConfig);

// firebase
//   .auth()
//   .setPersistence(firebase.auth.Auth.Persistence.LOCAL)
//   .then(function() {
//     // Existing and future Auth states are now persisted in the current
//     // session only. Closing the window would clear any existing state even
//     // if a user forgets to sign out.
//     // ...
//     // New sign-in will be persisted with session persistence.
//     return firebase.auth().signInWithEmailAndPassword(email, password);
//   })
//   .catch(function(error) {
//     // Handle Errors here.
//     var errorCode = error.code;
//     var errorMessage = error.message;
//   });

export const db = firebase.firestore();
export const auth = firebase.auth();
export const storageRef = firebase.storage().ref();
export const provider = new firebase.auth.GoogleAuthProvider();
